import {$, $$, getParentElementByTagName, hide, show} from "../../core/js/Dom.ts";
import {$get} from "../../core/js/Ajax.ts";
import {initDropzone} from "../../core/js/Dropzone.ts";
import {initTooltips} from "../../core/js/Tooltip.ts";
import {initNotesForm} from "../../core/js/Notes.ts";
import {initDatefield} from "../../core/js/Date.ts";
import {fadeOutFadeIn} from "../../core/js/Animate.ts";

export function handleShowAvis(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, 'button')
    if (target) {
        let url_instruction = window.location.href
        let tableau_url_instruction = url_instruction.split("/")
        let contentExiste = target.dataset.loaded === "true"
        const instruction = tableau_url_instruction[4]
        const service = target.dataset.service
        const avis = target.dataset.avis
        const cible = $(`#${target.getAttribute('aria-controls')}`)
        if (cible) resetAnnulation(cible)

        if (!contentExiste) {
            const url = `/instructions/ajax/recuperer_avis_par_service_consulte/${avis}/?service_id=${service}&instruction_id=${instruction}`
            $get(url).then((response) => {
                if (response.response.status === 200) {
                    target.dataset.loaded = "true"
                    if (cible) {
                        cible.innerHTML = response.body
                        initDropzone($(`#dropzone_form_${avis}`))
                        initTooltips(cible)
                        initNotesForm($(`.form_ajout_note`, cible))
                        handleAnnulerAvis(cible)
                        initDatefield('.btn-date-form', cible)
                        $$(`#accordion_prefecture button[id^="heading"]`).forEach(el => el.addEventListener('click', handleShowAvis))
                        $$(`#accordion button[id^="heading"]`, cible).forEach(el => el.addEventListener('click', handleShowAvis))
                    }
                }
            })
        }
    }
}

function resetAnnulation(container: HTMLElement) {
    const confirm = $('.confirmer_annulation', container)
    const annule = $('.annulation', container)
    annule?.classList.remove("animate__animated", "animate__fadeOut", "animate__fadeIn")
    confirm?.classList.remove("animate__animated", "animate__fadeOut", "animate__fadeIn")
    show(annule)
    hide(confirm)
}

function handleAnnulerAvis(container: HTMLElement) {
    const confirm = $('.confirmer_annulation', container)
    const annule = $('.annulation', container)
    if (confirm && annule) {
        annule?.addEventListener('click', () => {
            fadeOutFadeIn(annule, confirm)
        })
    }
}